import { render, staticRenderFns } from "./listar-recurso-acessibilidade.vue?vue&type=template&id=076487e1&"
import script from "./listar-recurso-acessibilidade.vue?vue&type=script&lang=ts&"
export * from "./listar-recurso-acessibilidade.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076487e1')) {
      api.createRecord('076487e1', component.options)
    } else {
      api.reload('076487e1', component.options)
    }
    module.hot.accept("./listar-recurso-acessibilidade.vue?vue&type=template&id=076487e1&", function () {
      api.rerender('076487e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recurso-acessibilidade/listar-recurso-acessibilidade.vue"
export default component.exports